import { ApplyCanvasSettings, CanvasSettings, getCanvas } from "../../../../components/Canvas/Canvas";
import { GGlowSpriteRender } from "../../../backgroundScene";
import { ConvertHexColorToVec3, GStack, GetVec2, GetVec3, Vector3 } from "../../../core/types";
import {
    GTime,
    MathClamp,
    MathGetVec3Length,
    MathHashf,
    MathImpulse,
    MathLerp,
    MathLerpVec3,
    MathMapToRange,
    MathSmoothstep,
} from "../../../core/utils";
import { RCombinerPass } from "../../../postprocess";
import { GPostProcessPasses } from "../../../renderingMain";

import { GVectorFieldInjector, VectorField } from "../../../vectorField";
import { GSceneDesc, SceneBase } from "../../scene";
import { SDFRender } from "../../sdf";
import { PayneSceneLightSwitch } from "./lightSwitch";
import { DensityRenderBullet } from "./lightSwitchDensityRender";
import { GUserInputDesc } from "../../../core/input";
import { TransformFromNDCToWorld } from "../../../helpers/transform";
import { GHallwaySceneCSS } from "../hallway/hallwayCSS";
import { PayneSceneHallway } from "../hallway/hallwayMain";
import { GAudioEngine } from "../../../core/audioEngine";

export class GLightSwitchSceneCSS {
    static setOceanViewTitleSubVisibility: React.Dispatch<React.SetStateAction<boolean>>;
    static setSubVisibility: React.Dispatch<React.SetStateAction<boolean>>;
    static setDiesVisibility: React.Dispatch<React.SetStateAction<boolean>>;
    static setResidenceSubVisibility: React.Dispatch<React.SetStateAction<boolean>>;
    static setSubQuoteIndex: React.Dispatch<React.SetStateAction<number>>;
}

export enum ESubSceneState {
    Rose = 0,
    Michelle,
    Mona,
    Valerie,
    Nicole,
    Phone,
}
export const SubSceneIndexNameMap: { [index: number]: string } = {
    [ESubSceneState.Rose]: "ROSE",
    [ESubSceneState.Michelle]: "MICHELLE",
    [ESubSceneState.Mona]: "MONA",
    [ESubSceneState.Valerie]: "VALERIE",
    [ESubSceneState.Nicole]: "NICOLE",
    [ESubSceneState.Phone]: "PHONE",
};

export class SubSceneDesc {
    PaintingColor = "#ffffff";
    PaintingBrightness = 1.6;
    LightColor = "#ffffff";
    LightIntensity = 3.0;
    LightRadius = 6.5;
    ProjectorColor = "#ffffff";

    ProjectorBrightness = 2.0;
    PaintTextureName = "";
    ProjTextureName: string | null = null;

    static GCurDesc = new SubSceneDesc();
    static CurPaintBrightnessCached = 0.0;
    static CurLightIntensityCached = 0.0;
    static CurProjIntensityCached = 0.0;

    static GetSubSceneDescRose(): SubSceneDesc {
        const desc = this.GCurDesc;
        /* desc.PaintingColor = "#cce2ff";
        desc.PaintingColor = "#a9c8ff"; */
        //desc.PaintingColor = "#6c9fff";
        desc.PaintingColor = "#97c1be";
        desc.LightColor = desc.PaintingColor;
        desc.LightColor = "#9BBEFF";
        //desc.LightColor = "#FF0000"; //Theatrical lighting
        desc.PaintingBrightness = 1.25;
        desc.ProjectorColor = "#007eff";
        desc.ProjectorBrightness = 6.0;
        desc.PaintTextureName = "paintRose3";
        desc.LightIntensity = 3.0;
        desc.ProjTextureName = null;
        return desc;
    }

    static GetSubSceneDescMichelle(): SubSceneDesc {
        const desc = this.GCurDesc;
        //desc.PaintingColor = "#ffd600";
        desc.PaintingColor = "#ffae00";
        desc.PaintingBrightness = 1.25;
        desc.LightColor = desc.PaintingColor;
        desc.ProjectorColor = "#007eff";
        desc.ProjectorBrightness = 3.0;
        desc.LightIntensity = 3.0;
        desc.PaintTextureName = "paintMich";
        desc.ProjTextureName = "projRose4";
        return desc;
    }

    static GetSubSceneDescMona(): SubSceneDesc {
        const desc = this.GCurDesc;
        if (1) {
            desc.PaintingColor = "#ff0092"; //ff00fe
            desc.PaintingBrightness = 0.85;
        } else {
            desc.PaintingColor = "#b62e8c";
            desc.PaintingBrightness = 1.75;
        }
        desc.LightColor = "#ff004c";
        desc.ProjectorColor = "#FFAE00";
        //desc.ProjectorColor = "#ff7700";
        //desc.ProjectorColor = "#ffd200";
        desc.LightIntensity = 5.0;
        desc.ProjectorBrightness = 3.0;
        desc.PaintTextureName = "paintMona3";
        desc.ProjTextureName = "projMich7";
        return desc;
    }

    static GetSubSceneDescValerie(): SubSceneDesc {
        const desc = this.GCurDesc;
        if (0) {
            //desc.PaintingColor = "#4f00ab";
            desc.PaintingColor = "#ffcce9";
        } else {
            desc.PaintingColor = "#dc00ac";
        }
        desc.PaintingBrightness = 1.4;
        desc.LightIntensity = 7;
        desc.LightRadius = 7.5;
        desc.LightColor = "#1400ff";
        desc.ProjectorColor = "#ff0031"; //
        desc.ProjectorBrightness = 3.25;
        desc.PaintTextureName = "paintVal";
        desc.ProjTextureName = "projMona1";
        return desc;
    }

    static GetSubSceneDescNicole(): SubSceneDesc {
        const desc = this.GCurDesc;
        desc.PaintingColor = "#607060";
        desc.PaintingBrightness = 1.5;
        desc.LightColor = "#284828";
        desc.LightIntensity = 7.0;
        desc.LightRadius = 6.5;
        if (1) {
            desc.ProjectorColor = "#2000ff"; //
        } else {
            desc.ProjectorColor = "#2f00ff"; //
        }
        desc.ProjectorBrightness = 6.0;
        desc.PaintTextureName = "paintNicole2";
        desc.ProjTextureName = "projValerie2";
        return desc;
    }

    static GetSubSceneDescPhone(): SubSceneDesc {
        const desc = this.GCurDesc;
        desc.PaintingColor = "#fff6cc";
        desc.PaintingBrightness = 1.5;
        desc.LightColor = "#fff6cc";
        desc.ProjectorColor = "#00862b";
        desc.ProjectorBrightness = 6.0;
        desc.PaintTextureName = "";
        desc.ProjTextureName = ``;
        desc.LightIntensity = 10.0;
        desc.LightRadius = 9.0;
        return desc;
    }

    static GetDescBasedOnState(inState: ESubSceneState): SubSceneDesc {
        switch (inState) {
            case ESubSceneState.Rose:
                return this.GetSubSceneDescRose();
            case ESubSceneState.Michelle:
                return this.GetSubSceneDescMichelle();
            case ESubSceneState.Mona:
                return this.GetSubSceneDescMona();
            case ESubSceneState.Valerie:
                return this.GetSubSceneDescValerie();
            case ESubSceneState.Nicole:
                return this.GetSubSceneDescNicole();
            case ESubSceneState.Phone:
                return this.GetSubSceneDescPhone();

            default:
                return this.GCurDesc;
        }
    }
}

export function SetUniformBufferParamsFromSceneDesc(desc: SubSceneDesc) {
    const uniformBuffer = SceneBase.UniformBuffer.Params;
    SceneBase.LightColorHex = desc.LightColor;
    ConvertHexColorToVec3(SceneBase.LightColorHex, uniformBuffer.LightColor);
    SceneBase.PaintingColorHex = desc.PaintingColor;
    ConvertHexColorToVec3(SceneBase.PaintingColorHex, uniformBuffer.EmmissiveColor);
    //this.MeshPainting.Material.Brightness = desc.PaintingBrightness;
    SceneBase.ProjectorColorHex = desc.ProjectorColor;
    ConvertHexColorToVec3(SceneBase.ProjectorColorHex, uniformBuffer.ProjectorColor);
    uniformBuffer.ProjectorIntensity.x = desc.ProjectorBrightness;
    uniformBuffer.LightIntensity1.x = desc.LightIntensity;
    uniformBuffer.PointLightRadius1.x = desc.LightRadius;
    SubSceneDesc.CurLightIntensityCached = desc.LightIntensity;
    SubSceneDesc.CurPaintBrightnessCached = desc.PaintingBrightness;
    SubSceneDesc.CurProjIntensityCached = desc.ProjectorBrightness;
}

export function SetNewSubSceneState(gl: WebGL2RenderingContext, inState: ESubSceneState, scene: PayneSceneLightSwitch) {
    const desc = SubSceneDesc.GetDescBasedOnState(inState);

    SetUniformBufferParamsFromSceneDesc(desc);

    if (inState == ESubSceneState.Phone) {
    } else {
        if (inState == 0) {
            scene.ProjectorTexture.bLoaded = false;
            //scene.PaintingTextureCur = GTexturePool.CreateTexture(gl, false, desc.PaintTextureName!, true, true);
            scene.PaintingTextureCur = PayneSceneHallway.GInstance!.PaintTexture;
        } else {
            scene.ProjectorTexture.bLoaded = true;
            scene.PaintingTextureCur = scene.PaintingTexturesArr[inState - 1];
            scene.ProjectorTexture.InnerTexture = scene.ProjectorTexturesArr[inState - 1]!;
            /* scene.ProjectorTexture.InnerTexture = scene.ProjectorTextureNext!;
            scene.PaintingTextureCur = scene.PaintingTextureNext; */
        }
        /* if (inState != ESubSceneState.Nicole) {
            const nextDesc = SubSceneDesc.GetDescBasedOnState(inState + 1);

            scene.ProjectorTextureNext = GTexturePool.CreateTexture(gl, false, nextDesc.ProjTextureName!, true, true);
            scene.PaintingTextureNext = GTexturePool.CreateTexture(gl, false, nextDesc.PaintTextureName!, true, true);
        } else {
        } */

        if (inState == ESubSceneState.Rose) {
            SceneBase.UniformBuffer.Params.LightColor2.Set3(0.85, 0.85, 0.85);
        } else if (inState == ESubSceneState.Valerie) {
            SceneBase.UniformBuffer.Params.LightColor2.Set3(0.3, 0.3, 0.3);
        } else if (inState == ESubSceneState.Nicole) {
            SceneBase.UniformBuffer.Params.LightColor2.Set3(0.25, 0.75, 0.25);
        } else {
            SceneBase.UniformBuffer.Params.LightColor2.Set3(0.55, 0.55, 0.55);
        }

        scene.MeshPainting.Material.AlbedoTexture = scene.PaintingTextureCur;
    }
}

function LightAnimationUpdate(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    const SubSceneStateHeartbeatDuration = 1.5; //0.4;

    scene.MeshPainting.Material.Brightness = SubSceneDesc.CurPaintBrightnessCached;
    SceneBase.UniformBuffer.Params.LightIntensity1.x = SubSceneDesc.CurLightIntensityCached;

    const brightFadeThres = 3.5;
    const brightFadeStartThres = 1.0;
    const projFadeOutBirhgtness = 0.3;
    if (scene.SubSceneStateTransitionParameterSec < brightFadeThres) {
        const minBrightness = 0.5;
        if (scene.SubSceneStateTransitionParameterSec < brightFadeStartThres) {
            scene.MeshPainting.Material.Brightness = SubSceneDesc.CurPaintBrightnessCached * minBrightness;
            SceneBase.UniformBuffer.Params.ProjectorIntensity.x = SubSceneDesc.CurProjIntensityCached;
        } else {
            let localT = MathMapToRange(
                scene.SubSceneStateTransitionParameterSec,
                brightFadeStartThres,
                brightFadeThres,
                minBrightness,
                1.0,
            );
            localT = MathClamp(localT, minBrightness, 1.0);
            //brScale = 1.0;
            //brScale = 0.0;
            scene.MeshPainting.Material.Brightness *= localT;
            SceneBase.UniformBuffer.Params.LightIntensity1.x = SubSceneDesc.CurLightIntensityCached * localT;

            if (scene.SubSceneStateTransitionParameterSec > brightFadeThres - 0.5) {
                let rndHash = MathHashf((GTime.Cur * 0.05) % 10.0);
                const rnd = (Math.sin(GTime.Cur) + 1.0) * 0.5;
                const flickThres = 0.16;
                if (!(rnd > 0.7 - flickThres && rnd < 0.7)) {
                    rndHash = 1.0;
                }
                rndHash = Math.max(0.85, rndHash);
                scene.MeshPainting.Material.Brightness *= rndHash;
                SceneBase.UniformBuffer.Params.LightIntensity1.x *= rndHash;
            }

            //Projector fade out
            {
                let projlocalT = MathMapToRange(
                    scene.SubSceneStateTransitionParameterSec,
                    brightFadeStartThres,
                    brightFadeThres,
                    1.0,
                    projFadeOutBirhgtness,
                );
                projlocalT = MathClamp(projlocalT, projFadeOutBirhgtness, 1.0);
                SceneBase.UniformBuffer.Params.ProjectorIntensity.x = SubSceneDesc.CurProjIntensityCached * projlocalT;

                SceneBase.UniformBuffer.Params.ProjectorIntensity.x *= MathClamp(localT, 0.95, 1.0);
            }
        }
    } else {
        if (!scene.bLightAnimFinished) {
            scene.MeshPainting.Material.bisEmmiter = true;
            scene.MeshPainting.Material.AlbedoTexture = scene.PaintingTextureCur;

            SceneBase.UniformBuffer.Params.LightIntensity1.x = SubSceneDesc.CurLightIntensityCached;
            /* SceneBase.UniformBuffer.Params.ProjectorIntensity.x =
                SubSceneDesc.CurProjIntensityCached * projFadeOutBirhgtness; */

            //scene.DensityRenderCenterImpulse(gl);

            scene.bLightAnimFinished = true;
        }
    }

    if (scene.SubSceneStateTransitionParameterSec < SubSceneStateHeartbeatDuration) {
        const paramNorm = scene.SubSceneStateTransitionParameterSec / SubSceneStateHeartbeatDuration;

        const lightShowThres = 0.18 * 1.3;
        const projShowThres = lightShowThres;
        const secondBeatThres = Math.max(projShowThres + 0.05, 0.5 * 0.3);
        const lightFlickerDur = 0.025;

        if (paramNorm < lightShowThres) {
            // eslint-disable-next-line prefer-const
            let curScale = 0.0;

            const fadeInStart = lightShowThres - 0.05 * 0.25;
            if (paramNorm > fadeInStart) {
                let curT = MathMapToRange(paramNorm, fadeInStart, lightShowThres, 0.0, 1.0);
                curT = MathSmoothstep(0.0, 1.0, curT);
                curScale = curT;
            }

            SceneBase.UniformBuffer.Params.ProjectorIntensity.x = curScale;
            scene.MeshPainting.Material.Brightness = curScale;
            SceneBase.UniformBuffer.Params.LightIntensity1.x = curScale;
        } else {
            if (!scene.bProjectorSoundPlayed) {
                DensityRenderBullet(gl, scene);
                //DensityRenderCenterImpulse(gl, scene);

                //Sound
                {
                    scene.PlayHeartbeatAddSound();
                }

                scene.bProjectorSoundPlayed = true;
            }

            if (!scene.bProjectorBulletAnimFired && paramNorm > secondBeatThres + lightFlickerDur) {
                DensityRenderBullet(gl, scene);
                //DensityRenderCenterImpulse(gl, scene);

                scene.bProjectorBulletAnimFired = true;
            }
            //SceneBase.UniformBuffer.Params.ProjectorIntensity.x = SubSceneDesc.CurProjIntensityCached * paramNorm;

            /* if (paramNorm > secondBeatThres && paramNorm < secondBeatThres + lightFlickerDur) {
                const scale = 0.25;
                scene.MeshPainting.Material.Brightness *= 0.0;
                SceneBase.UniformBuffer.Params.ProjectorIntensity.x *= 0.0;
            } */
        }

        const impulseStart = lightShowThres;
        const impulseMaxDur = 2.0;
        if (
            scene.SubSceneStateTransitionParameterSec > impulseStart &&
            scene.SubSceneStateTransitionParameterSec < impulseStart + impulseMaxDur
        ) {
            const t = scene.SubSceneStateTransitionParameterSec - impulseStart;
            RCombinerPass.FisheyeParam = MathImpulse(t, 3.5) * 0.2;
        } else {
            RCombinerPass.FisheyeParam = 0.0;
        }
    } else {
        {
            const blueColor = GStack.TempVec3_4;
            blueColor.Set3(0.0, 0.05, 1.0);
            const darkBlueColor = GStack.TempVec3_3;
            darkBlueColor.Set3(0.0, 0.0, 0.06);

            let colorFadeThres = 3.0;
            /* if (scene.CurSceneState == ESubSceneState.Mona) {
                colorFadeThres = 4.0;
            } */
            if (scene.CurSceneState == ESubSceneState.Valerie) {
                colorFadeThres = 4.0;
            }
            if (scene.CurSceneState == ESubSceneState.Nicole) {
                colorFadeThres = 4.0;
            }
            if (scene.CurSceneState !== ESubSceneState.Phone) {
                if (scene.SubSceneStateTransitionParameterSec > colorFadeThres) {
                    const newColor = MathLerpVec3(SceneBase.UniformBuffer.Params.ProjectorColor, darkBlueColor, 0.05);
                    SceneBase.UniformBuffer.Params.ProjectorColor.Set(newColor);
                }
            }
        }
    }
}

export function OnSubSceneStateTransitionUpdate(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    scene.SubSceneStateTransitionParameterSec += GTime.Delta;

    /* scene.MeshPainting.Material.Brightness =
        SubSceneDesc.CurPaintBrightnessCached + Math.sin(Math.PI * 0.5 * GTime.Cur) * 0.2 - 0.15; */

    LightAnimationUpdate(gl, scene);
}

export function TransitionSceneToPhoneState(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    scene.TimeSinceFirstSceneRender = 0.0;

    GLightSwitchSceneCSS.setSubVisibility(false);

    GHallwaySceneCSS.SetNewPage(2);

    RCombinerPass.bVolumeTextureReadEnabled = 1;

    const camDiffY = 2.75 - GSceneDesc.Camera.Position.y;
    const camDiffZ = -10.5 - GSceneDesc.Camera.Position.z;
    scene.SwitchRope.RopeOriginPos.y += camDiffY;
    scene.SwitchRope.RopeOriginPos.y += 0.4;
    scene.SwitchRope.RopeOriginPos.z += camDiffZ;
    scene.SwitchRope.Rope.NumSolverIterations = 12;
    /* for (let p = scene.SwitchRope.Rope.Points.length - 1; p > 0; p--) {
		const point = scene.SwitchRope.Rope.Points[p];
		point.PositionCur.y += camDiffY;
        point.PositionCur.z += camDiffZ;
	} */

    scene.CurSceneState = ESubSceneState.Phone;
    scene.AllMeshesArr = scene.HotlineMeshesArr;
    GSceneDesc.Camera.Position.y = 2.75;
    GSceneDesc.Camera.Position.z = -10.5;
    const buf = SceneBase.UniformBuffer.Params;
    //lighting setup
    {
        buf.PointLightPos1.Set3(-4.37, 2.85, -200.52);
        buf.PointLightPos2.Set3(2.0, -1.59, -5.43);
        buf.SpotlightPos.Set3(0.0, 1.1, -20.0);
        buf.SpotlightPos2.Set3(1.6, 2.5, -3.4);
        buf.SpotlightTargetPos2.Set3(-1.0, 0.0, scene.MeshPhone.Position.z);
        buf.SpotlightPos3.Set3(-4.8, 4.25, -0.4);
        buf.LightIntensity1.x = 8;
        buf.PointLightRadius1.x = 6.0;
        buf.AmbientLight.x = 6.0;

        ConvertHexColorToVec3("#fff6cc", buf.LightColor2);

        buf.ProjectorPos.y = 3.5;
        buf.ProjectorTargetPos.y = 3.86;
        buf.ProjectorXYRatio.x = 2.0;
        buf.ProjectorZoom.x = 1.84;
        buf.ProjectorIntensity.x = 0.67;
        SubSceneDesc.CurProjIntensityCached = 0.67;
        buf.ProjectorXYRatio.x = 2.17;

        //VectorField.GFullscreenInstance!.DensityDecay = 0.2;
        VectorField.GFullscreenInstance!.DensityDecay = 0.05;
        VectorField.GFullscreenInstance!.DensityAlphaDecay = 2.2;
        VectorField.GFullscreenInstance!.VelocityDecay = 1.5;
        VectorField.GFullscreenInstance!.EProcNoiseMode = 1;

        //green state
        /* {
            SceneBase.LightColorHex = "#42ff00";
            ConvertHexColorToVec3(SceneBase.LightColorHex, buf.LightColor);
            ConvertHexColorToVec3("#b0004c", buf.LightColor2);

            SubSceneDesc.CurLightIntensityCached = 15.0;
            buf.LightIntensity1.x = 17;
            buf.LampLightIntensity.x = 0.55;
            buf.LampLightRadius.x = 8.0;
            GPostProcessPasses.Bloom!.Threshold = 0.01;
        } */
    }

    {
        CanvasSettings.Brightness = 1.35;
        ApplyCanvasSettings(getCanvas());

        RCombinerPass.Exposure = 1.15;
    }

    scene.ProjectorTexture.bLoaded = false;
    /* scene.ProjectorTexture.InnerTexture = GTexturePool.CreateTexture(
        gl,
        false,
        "smile",
        true,
        true,
        false,
        scene.ProjectorTexture,
    ); */

    scene.SDFSceneRender = new SDFRender(gl, scene.SceneSDFDescPhoneScene!);
    scene.ShaderBasePassCurScene = scene.ShaderBasePassPhoneScene;

    scene.pCurSDFMesh = scene.MeshPhone;
    scene.pCurSDFMesh2 = scene.MeshPhoneHandle;

    SceneBase.UniformBuffer.Params.OccluderPlaneCenter.Set3(0, 3.0, -0.01);
    SceneBase.UniformBuffer.Params.OccluderPlaneExtent.Set3(2.2, 2.7, 0.1);
    SceneBase.UniformBuffer.Params.OccluderPlaneExtent.x *= 1.025;
    SceneBase.UniformBuffer.Params.OccluderPlaneExtent.y *= 1.025;

    SceneBase.UniformBuffer.Params.SceneBoundsExtent.Set3(5.0, 2.0, 2.0);
    SceneBase.UniformBuffer.Params.SceneBoundsCenter.Set3(0.0, 2.0, -2.0);
    /* SceneBase.UniformBuffer.Params.SceneBoundsExtent.z = 2.0;
    SceneBase.UniformBuffer.Params.SceneBoundsCenter.z = -2.0; */

    const probeRadius = SceneBase.LightprobesManager.ProbeRadius;
    SceneBase.LightprobesManager.InitProbesPositions(
        SceneBase.UniformBuffer.Params.SceneBoundsCenter,
        GetVec3(
            SceneBase.UniformBuffer.Params.SceneBoundsExtent.x - probeRadius,
            SceneBase.UniformBuffer.Params.SceneBoundsExtent.y - probeRadius,
            SceneBase.UniformBuffer.Params.SceneBoundsExtent.z - probeRadius,
        ),
    );

    GGlowSpriteRender.GInstance!.bEnabled = false;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function TransitionSceneToLightSwitch(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    GHallwaySceneCSS.setVisibilityMain(false);

    GHallwaySceneCSS.SetNewPage(1);

    //Desc
    {
        //Assign Camera Desc
        GSceneDesc.Camera.Position.x = 0.0;
        GSceneDesc.Camera.Position.y = 0.1;
        GSceneDesc.Camera.Position.z = -12.5;
        //GSceneDesc.Camera.Position.z = -14.0;
        GSceneDesc.Camera.ZoomScale = 2.5;

        RCombinerPass.BloomStrength = 0.9;
        GPostProcessPasses.Bloom!.Threshold = 0.1;
        GPostProcessPasses.Bloom!.PreBrightness = 1.0;

        //GPostProcessPasses.Bloom!.Threshold = 0.0;

        {
            CanvasSettings.Brightness = 1.0;
            //CanvasSettings.Contrast = 0.995;
            const canvas = getCanvas();
            ApplyCanvasSettings(canvas);

            RCombinerPass.Exposure = 1.0;
            RCombinerPass.ColorContrast = 1.0;
        }

        //RCombinerPass.DispersionOffsetScale = 1.0;

        RCombinerPass.LensFlareScale = 0.2;

        const buf = SceneBase.UniformBuffer.Params;
        buf.AmbientLight.x = 0.1;

        buf.LightIntensity1.x = 3.0;

        buf.SpotlightPos.z = -10.5;

        GGlowSpriteRender.GInstance!.bEnabled = true;
    }
}

export function TransitionToNextSubSceneState(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    scene.bLightAnimFinished = false;
    scene.bProjectorBulletAnimFired = false;
    scene.bProjectorSoundPlayed = false;
    scene.SubSceneStateTransitionParameterSec = 0;
    scene.CurSceneState++;
    /* if (scene.CurSceneState > ESubSceneState.Nicole) {
        scene.CurSceneState = ESubSceneState.Rose;
    } */
    SetNewSubSceneState(gl, scene.CurSceneState, scene);
    if (scene.CurSceneState == ESubSceneState.Phone) {
        TransitionSceneToPhoneState(gl, scene);
    }
    scene.VectorFieldProjector.ClearDensity(gl);
    scene.VectorFieldProjector.ClearVectorField(gl);

    //scene.DensityRenderCenterImpulse(gl);

    const Pos0 = GStack.TempVec3;
    Pos0.Set3(-3.57, -1.55, -5.27);
    const Pos1 = GStack.TempVec3_2;
    //Pos1.Set3(-3.0, -1.4, -6.5);
    Pos1.Set3(-3.25, -1.4, -6.5);
    const lerpParam = scene.CurSceneState / ESubSceneState.Nicole;
    const curPos = MathLerpVec3(Pos0, Pos1, lerpParam);
    scene.MeshBird.Position.Set(curPos);
}

export function OnScriptUpdateMeshesForCurSceneState(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    /* {
        const paintingPosZ = SceneBase.UniformBuffer.Params.OccluderPlaneCenter.z;
        scene.MeshPainting.Position.z = paintingPosZ;
        scene.MeshPaintingFrameWood.Position.z = paintingPosZ;
        scene.MeshPaintingFrameMetal.Position.z = paintingPosZ;
    } */
    {
        const offset = new Vector3(1.0769999027252197, 2.559999942779541, -0.5900001525878906);
        scene.MeshEye.Position.Set3(
            scene.MeshBird.Position.x + offset.x,
            scene.MeshBird.Position.y + offset.y,
            scene.MeshBird.Position.z + offset.z,
        );
        scene.MeshEye.Material.Brightness = 0.75 + Math.max(0.0, Math.sin(GTime.Cur)) * 0.25;
    }
}

export function OnPhoneSceneUpdate(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    const uniformBuffer = SceneBase.UniformBuffer.Params;
    const audioContext = GAudioEngine.Instance!.Context;
    const timeSinceFirstRender = scene.TimeSinceFirstSceneRender;

    scene.bPhonePickedUpThisFrame = false;

    //1. Full lit room
    const FLTransStart = 1.0;
    const FLTransDur = 5.0;
    //2. Green Room
    //3. Phone Alone
    //4. Wings

    if (!scene.bPhonePickedUp) {
        if (timeSinceFirstRender < 1.0) {
            RCombinerPass.EFullscreenVFXMode = 2;
            CanvasSettings.Brightness = 1.0;
            //CanvasSettings.Contrast = 1.05;
            ApplyCanvasSettings(getCanvas());
            GLightSwitchSceneCSS.setDiesVisibility(true);

            scene.SoundOnFireOn();
        } else {
            if (timeSinceFirstRender < 3.0) {
                RCombinerPass.EFullscreenVFXMode = 0;

                scene.SoundOnFireOff();
            }
            CanvasSettings.Brightness = 1.35;
            CanvasSettings.Contrast = 1.0;
            ApplyCanvasSettings(getCanvas());
            GLightSwitchSceneCSS.setDiesVisibility(false);

            if (audioContext) {
                if (!scene.SoundPhone.bIsPlaying) {
                    const ndcPos = GStack.TempVec3_2;
                    ndcPos.Set(scene.MeshPhoneHandleSpatialController.PositionWS);
                    ndcPos.Negate(uniformBuffer.CameraPosition);
                    ndcPos.x *= uniformBuffer.CameraZoom.x;
                    ndcPos.y *= uniformBuffer.CameraZoom.x;
                    ndcPos.x /= uniformBuffer.ScreenRatio.x;
                    ndcPos.x /= 0.1 + ndcPos.z;
                    ndcPos.y /= 0.1 + ndcPos.z;

                    GVectorFieldInjector.GInstance?.InjectImpulse(
                        gl,
                        VectorField.GFullscreenInstance!,
                        GetVec2(ndcPos.x, ndcPos.y),
                    );

                    scene.PhoneRingStartTime = 0.0;
                }
                scene.SoundPhone.Play(audioContext, true);

                scene.PhoneRingStartTime += GTime.Delta;
            }

            const impulseStart = 1.0;
            const impulseMaxDur = 2.0;
            if (timeSinceFirstRender < impulseStart + impulseMaxDur) {
                const t = timeSinceFirstRender - impulseStart;
                //RCombinerPass.FisheyeParam = MathImpulse(t, 7.0) * 0.3;
                RCombinerPass.FisheyeParam = MathImpulse(t, 2.0) * -0.075;
            } else if (scene.TimeSinceFirstSceneRender < impulseStart + impulseMaxDur + 1.0) {
                RCombinerPass.FisheyeParam = 0.0;
            }
        }
    }

    //Transition From Full lit to Green
    if (timeSinceFirstRender > FLTransStart && timeSinceFirstRender <= FLTransStart + FLTransDur) {
        const transParam = MathMapToRange(timeSinceFirstRender, FLTransStart, FLTransStart + FLTransDur, 0.0, 1.0);

        //CanvasSettings.Saturation = MathLerp(1.25, 1.0, transParam);
        RCombinerPass.ColorContrast = MathLerp(1.0, 1.015, transParam);

        const initColor = GStack.TempVec3_2;
        ConvertHexColorToVec3("#fff6cc", initColor);

        const greenCol = GStack.TempVec3;
        ConvertHexColorToVec3("#42ff00", greenCol);

        const redColor = GStack.TempVec3_3;
        ConvertHexColorToVec3("#b0004c", redColor);

        const lampColor = MathLerpVec3(initColor, greenCol, transParam);
        const phoneColor = MathLerpVec3(initColor, redColor, transParam);

        uniformBuffer.LightColor.Set(lampColor);
        uniformBuffer.EmmissiveColor.Set(lampColor);
        uniformBuffer.LightColor2.Set(phoneColor);

        //uniformBuffer.LampLightRadius.x = MathLerp(9.0, 8.0, transParam);
        uniformBuffer.LampLightIntensity.x = MathLerp(0.75, 0.35, transParam);

        uniformBuffer.LightIntensity1.x = MathLerp(8.0, 20.0, transParam);

        ApplyCanvasSettings(getCanvas());
    }

    //Lamp flicker
    {
        let rndHash = MathHashf((GTime.Cur * 0.005) % 10.0);
        let rnd = (Math.sin(GTime.Cur) + 1.0) * 0.5;
        const flickThres = 0.06;
        if (!(rnd > 0.7 - flickThres && rnd < 0.7)) {
            rndHash = 1.0;
        }
        rnd = Math.max(0.85, rnd);
        rndHash = Math.max(0.5, rndHash);
        rnd *= rndHash;
        SceneBase.UniformBuffer.Params.LampFlickerScale.x = rnd;

        const lampBrightness = Math.sqrt(MathClamp(uniformBuffer.LampLightIntensity.x * 2.0, 0.0, 1.0));

        scene.MeshLampRightArr[2].Material.Brightness = 0.7 * rnd * lampBrightness;
        scene.MeshLampRightArr[3].Material.Brightness = 0.7 * rnd * lampBrightness;

        scene.MeshLampLeftArr[2].Material.Brightness = 0.7 * lampBrightness;
        scene.MeshLampLeftArr[3].Material.Brightness = 0.7 * lampBrightness;
    }

    //Spatial Control
    const control = scene.MeshPhoneHandleSpatialController;
    const phone = scene.MeshPhoneHandle;
    const handleInitialHeight = 0.56;
    const handleToUserRaise = 0.075;
    let phoneCloseToUser = scene.bPhonePickedUp;
    if (!scene.bPhonePickedUp) {
        const inputPosWS = GStack.TempVec3;
        TransformFromNDCToWorld(
            GUserInputDesc.InputPosCurNDC,
            -GSceneDesc.Camera.Position.z + phone.Position.z,
            inputPosWS,
        );
        inputPosWS.Negate(phone.Position);
        const handleToUserSpeed = 0.1 * 0.25;
        if (MathGetVec3Length(inputPosWS) < 1.0) {
            phoneCloseToUser = true;
            phone.Position.y = MathLerp(phone.Position.y, handleInitialHeight + handleToUserRaise, handleToUserSpeed);
        } else {
            phone.Position.y = MathLerp(phone.Position.y, handleInitialHeight, handleToUserSpeed);
        }
    }

    if (phone && phone.bCanDraw) {
        control.BoundsExtent.Set(phone.InitBBoxExtentNorm!);
        control.BoundsExtent.Mul(phone.Scale.x);

        control.OnUpdate();

        if (control.bDragState) {
            if (!scene.bPhonePickedUp && Math.abs(phone.Position.y - handleInitialHeight) > handleToUserRaise + 0.1) {
                scene.bPhonePickedUp = true;
                scene.bPhonePickedUpThisFrame = true;
                scene.SoundPhone.Stop();
                if (audioContext) {
                    //scene.SoundAh.Play(audioContext);
                    scene.SoundHotline.Play(audioContext);
                }
            }

            control.PositionWS.x = MathClamp(control.PositionWS.x, -1.0, 1.0);
            control.PositionWS.y = MathClamp(control.PositionWS.y, handleInitialHeight + 0.2, 2.5);

            //phone.Position.Set(control.PositionWS);
            const lerpAmount = 0.02;
            phone.Position.x = MathLerp(phone.Position.x, control.PositionWS.x, lerpAmount);
            phone.Position.y = MathLerp(phone.Position.y, control.PositionWS.y - 0.2, lerpAmount);
            phone.Position.z = MathLerp(phone.Position.z, control.PositionWS.z, lerpAmount);

            //phone.Position.y -= 0.2;
        } else {
            control.PositionWS.Set(phone.Position);
            control.PositionWS.y += 0.2;
        }
    }

    //let ghostParam = 0.0;

    if (phoneCloseToUser) {
        uniformBuffer.PhoneGhostEffectParam.x = Math.min(0.5, uniformBuffer.PhoneGhostEffectParam.x + 0.01);
    }

    if (phoneCloseToUser || (scene.bPhonePickedUp && scene.PhonePickupTimeParam < 4.0)) {
        uniformBuffer.LampLightIntensity.x = MathLerp(uniformBuffer.LampLightIntensity.x, 0.0, 0.01);
        RCombinerPass.ColorContrast = MathLerp(RCombinerPass.ColorContrast, 1.045, 0.01);
        uniformBuffer.LightIntensity1.x = MathLerp(uniformBuffer.LightIntensity1.x, 30.0, 0.01);

        uniformBuffer.SpotlightPos.z = MathLerp(uniformBuffer.SpotlightPos.z, -40, 0.01);
    }

    if (!scene.bPhonePickedUp && scene.PhoneRingStartTime < 2.0) {
        phone.Orientation.y = Math.sin(GTime.Cur * 130.0) * 0.027;
    }

    if (scene.bPhonePickedUp) {
        const phoneT = scene.PhonePickupTimeParam;

        const phoneRotationDuration = 4.0;
        const wingsStage1Start = phoneRotationDuration + 1.0;
        const wingsStage1Dur = 2.0;
        const wingsStage2Dur = 0.3;

        let ECurWingsStage = 0;
        let wingsStageParamT = 0;
        if (phoneT > wingsStage1Start + wingsStage1Dur + wingsStage2Dur - 0.01) {
            //transition already performed
            ECurWingsStage = 3;
            scene.bSceneFinished = true;

            console.log(phoneT);
        } else if (phoneT > wingsStage1Start + wingsStage1Dur) {
            ECurWingsStage = 2;

            wingsStageParamT = MathMapToRange(
                scene.PhonePickupTimeParam,
                wingsStage1Start + wingsStage1Dur,
                wingsStage1Start + wingsStage1Dur + wingsStage2Dur,
                0.0,
                1.0,
            );
        } else if (scene.PhonePickupTimeParam > wingsStage1Start) {
            ECurWingsStage = 1;

            wingsStageParamT = MathMapToRange(
                scene.PhonePickupTimeParam,
                wingsStage1Start,
                wingsStage1Start + wingsStage1Dur,
                0.0,
                1.0,
            );
        } else {
            wingsStageParamT = MathMapToRange(scene.PhonePickupTimeParam, 0.0, wingsStage1Start, 0.0, 1.0);
        }

        if (phoneT < phoneRotationDuration) {
            let rotT = MathMapToRange(phoneT, 0.0, phoneRotationDuration, 0.0, 1.0);

            if (rotT >= 0.5) {
                rotT = MathSmoothstep(0.0, 1.0, rotT);
            }

            //x 0.2 y 2.6 z. 0.10

            phone.Orientation.x = 0.3 * rotT;
            phone.Orientation.y = -2.6 * rotT;
            phone.Orientation.z = -0.1 * rotT;
        }

        if (phoneT > phoneRotationDuration - 2.5) {
            GLightSwitchSceneCSS.setResidenceSubVisibility(true);
        }

        if (ECurWingsStage == 0) {
            GPostProcessPasses.Bloom!.Threshold = MathLerp(0.1, 0.05, wingsStageParamT);

            uniformBuffer.PhoneGhostEffectParam.x = MathLerp(0.55, 0.95, wingsStageParamT);
        } else if (ECurWingsStage == 1) {
            //subs

            uniformBuffer.PhoneGhostEffectParam.x = MathLerp(0.95, 1.0, Math.sqrt(wingsStageParamT));

            uniformBuffer.LampLightIntensity.x = 0.35 * Math.sqrt(wingsStageParamT);

            uniformBuffer.PointLightRadius1.x = MathLerp(6.0, 3.0, wingsStageParamT);

            //light flicker
            {
                const flickerThres = wingsStageParamT * 0.5; //lower - less flicker
                const flickerMax = MathLerp(1.0, 0.85, wingsStageParamT);

                let rndHash = MathHashf((GTime.Cur * 0.005) % 10.0);
                if (rndHash > flickerThres) {
                    rndHash = 1.0;
                }
                rndHash = Math.max(flickerMax, rndHash);

                uniformBuffer.LightIntensity1.x = 30.0 * rndHash;

                //scene.NicPaintingMesh!.Material.Brightness = Math.min(0.04, MathLerp(0.01, 0.045, wingsStageParamT));
            }
        } else if (ECurWingsStage == 2) {
            //light flicker
            {
                const flickerThres = 0.5; //lower - less flicker
                const flickerMax = 0.7;

                let rndHash = MathHashf((GTime.Cur * 0.005) % 10.0);
                if (rndHash > flickerThres) {
                    rndHash = 1.0;
                }
                rndHash = Math.max(flickerMax, rndHash);

                uniformBuffer.LightIntensity1.x = 30.0 * rndHash;
            }

            RCombinerPass.ColorContrast = MathLerp(1.055, 1.04, wingsStageParamT);

            RCombinerPass.BloomStrength = MathLerp(0.9, 1.5, wingsStageParamT);

            uniformBuffer.PointLightRadius1.x = MathLerp(3.0, 0.0, wingsStageParamT * wingsStageParamT);

            scene.NicPaintingMesh!.Material.Brightness = Math.min(0.04, MathLerp(0.01, 0.045, wingsStageParamT));

            ///scene.NicPaintingMesh!.Material.Brightness = MathLerp(0.045, 0.05, wingsStageParamT);

            {
                const initColor = GStack.TempVec3_2;
                ConvertHexColorToVec3("#fff6cc", initColor);

                const greenCol = GStack.TempVec3;
                ConvertHexColorToVec3("#42ff00", greenCol);

                const lampColor = MathLerpVec3(greenCol, initColor, wingsStageParamT * 0.0);

                uniformBuffer.LightColor.Set(lampColor);
                uniformBuffer.EmmissiveColor.Set(lampColor);
            }
        }

        if (phoneT > phoneRotationDuration) {
            scene.bRenderWings = true;
        }

        scene.PhonePickupTimeParam += GTime.Delta;
    }

    scene.TimeSinceFirstSceneRender += GTime.Delta;
}

function SubsUpdate(scene: PayneSceneLightSwitch) {
    GLightSwitchSceneCSS.setSubVisibility(true);

    switch (scene.CurSceneState) {
        case ESubSceneState.Rose:
            GLightSwitchSceneCSS.setSubQuoteIndex(0);
            break;
        case ESubSceneState.Michelle:
            GLightSwitchSceneCSS.setSubVisibility(false);
            break;
        case ESubSceneState.Mona:
            GLightSwitchSceneCSS.setSubQuoteIndex(1);
            break;
        case ESubSceneState.Valerie:
            GLightSwitchSceneCSS.setSubQuoteIndex(2);
            break;
        case ESubSceneState.Nicole:
            GLightSwitchSceneCSS.setSubQuoteIndex(3);
            break;
        case ESubSceneState.Phone:
            {
                //GLightSwitchSceneCSS.setSubQuoteIndex(3);
            }
            break;
        default:
            GLightSwitchSceneCSS.setSubVisibility(false);
    }
}

export function LightSwitchOnUpdateAdditional(scene: PayneSceneLightSwitch) {
    const buf = SceneBase.UniformBuffer.Params;

    const audioContext = GAudioEngine.Instance.Context;
    if (audioContext) {
        if (scene.SoundRoomNoise.Buffer) {
            scene.SoundRoomNoise.Play(audioContext, true, Math.random() * scene.SoundRoomNoise.Buffer.duration * 0.5);
        }
    }

    const titleStart = 2.0;
    const titleDur = 2.5;
    if (scene.TimeSinceFirstSceneRender > titleStart && scene.TimeSinceFirstSceneRender <= titleStart + titleDur) {
        GLightSwitchSceneCSS.setOceanViewTitleSubVisibility(true);

        const hallway = PayneSceneHallway.GInstance!;
        if (audioContext) {
            if (scene.TimeSinceFirstSceneRender < titleStart + 1.0) {
                if (!hallway.SoundImpactLow.bIsPlaying) {
                    hallway.SoundImpactLow.Play(audioContext);
                }
            }
        }
    } else {
        GLightSwitchSceneCSS.setOceanViewTitleSubVisibility(false);
    }

    if (scene.TimeSinceFirstSceneRender < titleStart) {
        const t = 1.0 - scene.TimeSinceFirstSceneRender / (titleStart * 0.75);
        const pyrSound = PayneSceneHallway.GInstance!.SoundPyramid;
        if (pyrSound.bIsPlaying) {
            pyrSound.Gain!.gain.value = PayneSceneHallway.GInstance!.SoundPyramidInitialGain * t * t;
        }
        const slowSweepSound = PayneSceneHallway.GInstance!.SoundSlowMotionEnd;
        if (slowSweepSound.bIsPlaying) {
            slowSweepSound.Stop();
        }
    }

    const subsShowStart = titleStart + 2;
    const cordRevealDuration = 6.0;

    if (
        scene.TimeSinceFirstSceneRender > subsShowStart &&
        scene.TimeSinceFirstSceneRender < subsShowStart + cordRevealDuration
    ) {
        // eslint-disable-next-line prefer-const
        let curT = MathMapToRange(
            scene.TimeSinceFirstSceneRender,
            subsShowStart,
            subsShowStart + cordRevealDuration,
            0.0,
            1.0,
        );
        curT = MathSmoothstep(0.0, 1.0, curT);

        const spotlightHeight = MathLerp(-2.3, 2.5, curT);
        buf.SpotlightPos2.x = spotlightHeight;

        if (scene.bCustomEventFlag == 0) {
            scene.bCustomEventFlag = 1;
        }
    }

    const impulseStart = 0.0;
    const impulseMaxDur = 2.0;
    if (
        scene.TimeSinceFirstSceneRender > impulseStart &&
        scene.TimeSinceFirstSceneRender < impulseStart + impulseMaxDur
    ) {
        const t = scene.TimeSinceFirstSceneRender - impulseStart;
        //RCombinerPass.FisheyeParam = MathImpulse(t, 7.0) * 0.3;
        RCombinerPass.FisheyeParam = MathImpulse(t, 2.0) * -0.075;
    } else if (scene.TimeSinceFirstSceneRender < impulseStart + impulseMaxDur + 1.0) {
        RCombinerPass.FisheyeParam = 0.0;
    }

    if (scene.TimeSinceFirstSceneRender > subsShowStart) {
        SubsUpdate(scene);
    } else {
        GLightSwitchSceneCSS.setSubVisibility(false);
    }

    scene.TimeSinceFirstSceneRender += GTime.Delta;
}
